import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const authHeader = () => {
  const t = localStorage.getItem("tv_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tv_token");
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const formatError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  if (e?.message === "Network Error") return "Could not reach True Vision. Check your connection and retry.";
  return "Something went wrong. Please try again.";
};

export const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_authentic-gi-market/artifacts/enmbd7go_12c0bcfd6bac402a8e10c04e91d9096e.png";

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data; // {path, url, kind, content_type}
};

export const fileUrl = (p) => (p ? `${API}/files/${p}` : "");

// Trigger a browser download from an authenticated endpoint (uses stored token)
export const downloadBlob = async (path, filename) => {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click();
  a.remove(); URL.revokeObjectURL(url);
};
